import { render, staticRenderFns } from "./EditStaffModal.vue?vue&type=template&id=618f7304&scoped=true"
import script from "./EditStaffModal.vue?vue&type=script&lang=js"
export * from "./EditStaffModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f7304",
  null
  
)

export default component.exports